export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12149.ef1b73fa.jpg";